<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent scrollable width="auto" :fullscreen="$vuetify.breakpoint.mobile">
      <v-form ref="formRecibo" v-model="valid" lazy-validation @submit.prevent="saveData">
        <v-card tile>
          <v-toolbar flat dark color="primary" class="max-height">
            <v-toolbar-title v-if="isbenitojuarez"> Generar Nuevo Recibo Benito Juarez </v-toolbar-title>
            <v-toolbar-title v-else> Generar Nuevo Registro de Cobro. </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeDialog"> <v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>

          <v-card-text class="pa-4">
            <v-row no-gutters>
              <v-col cols="10" sm="10"> 
                <v-combobox
                  v-model="persona"
                  :items="personas"
                  item-text="nombres"
                  :search-input.sync="searchPersona"
                  :loading="searchingpersona"
                  :loader-height="4"
                  prepend-inner-icon="mdi-account-tie"
                  autofocus
                  outlined
                  dense
                  label="Estudiante"
                  :rules="fieldRules"
                  :hint="showHint(persona)" 
                  persistent-hint
                  return-object></v-combobox> 
                </v-col>
              <v-col cols="2" sm="2" v-if="$store.state.CARGO && ($store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 25)">
                <v-btn v-if="programas && programas.length>0" tile color="purple" small dark class="ml-2 px-2" @click="openregistrarCaja()" > <v-icon left>mdi-package-variant</v-icon>  Caja  </v-btn>
              </v-col>
              <!-- 
              <v-col cols="1" sm="1">
                <v-checkbox> Buscar por carnet </v-checkbox>
              </v-col> 
              -->
            </v-row>

            <div v-if="persona">
              <v-divider class="mt-0 mb-2"></v-divider>
              <v-row>
                <v-col cols="10" class="py-1">
                  <v-select
                    v-model="programa"
                    :items="programas"
                    :loading="loadingprogramas"
                    :loader-height="4"
                    item-text="nombre_compuesto"
                    outlined
                    dense
                    label="Programa (Solo aparecen donde esta en estado inscrito)"
                    return-object
                    :hint="msgprogs"
                    persistent-hint>
                    <template v-slot:no-data>
                      <div
                        role="listbox"
                        tabindex="-1"
                        class="v-list v-select-list v-sheet theme--light v-list--dense theme--light">
                        <div tabindex="-1" class="v-list-item theme--light">
                          <div class="v-list-item__content">
                            <div class="v-list-item__title">
                              No se encontro ningún programa del estudiante en esta sede
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </v-select>
                 <!--  <p class="mt-0 mb-0 ml-4">
                    <small> tipo de facturacion: {{ tipo_facturacionTxt }} </small>
                  </p> -->
                  <p
                    v-if="razonestxt.length"
                    class="mt-0 mb-0 ml-4 blue--text text-decoration-underline manito"
                    @click="verrazones()">
                    ver las razones si no aparecen los programas.
                  </p>
                </v-col>
                <template v-if="programa">
                  <v-col v-if="!plan_inscripcion" cols="2">
                    <v-btn small rounded color="amber" @click="generatePlan(false)"> Regularizar </v-btn>
                  </v-col>
                  <v-col
                    v-else-if="!programa.ifcode || !this.plan_inscripcion.aprobado || !this.programa.estado_plan_id"
                    cols="2">
                    <v-btn small rounded color="orange" @click="openConfirmDialogAprobe">Revisar Plan </v-btn>
                  </v-col>
                  <v-col v-else>
                    <small v-if="plan_inscripcion">
                      <b> {{ `${programa.nombre_compuesto.slice(0, 1)}-${programa.programa_id}` }} </b>, Inscripcion:
                      <b>{{ programa.id }}</b>
                    </small>
                  </v-col>
                </template>
              </v-row>
              <template v-if="programa">
                <!-- ======secction form Data Extra========= -->
                <v-sheet outlined class="pa-2 pb-0" rounded="" color="grey lighten-3">
                  <v-row>
                    <v-col cols="4" class="py-0">
                      <v-select
                        v-model="forma"
                        :items="formas_pago"
                        :rules="fieldRules"
                        :disabled="!tipo_facturacion"
                        :loading="loadingformas"
                        item-text="nombre"
                        outlined
                        dense
                        label="Forma de Pago"
                        return-object></v-select>
                    </v-col>
                    <v-col cols="4" class="py-0">
                      <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :rules="fieldRules"
                            readonly
                            label="Fecha de Pago"
                            v-model="fecha_pago"
                            outlined
                            dense
                            v-bind="attrs"
                            v-on="on"></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date"
                          locale="es-ES"
                          @input="menu1 = false"
                          :max="maxDate()"></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="4" class="py-0">
                      <!-- <v-text-field v-model="num_factura" outlined dense label="N° Factura"></v-text-field> -->
                    </v-col>
                    <v-col cols="4" class="py-0">
                      <v-text-field
                        v-model.trim="nombre_depositante"
                        outlined
                        dense
                        :rules="fieldRules"
                        label="Nombre de Depositante"></v-text-field>
                    </v-col>
                    <v-col cols="4" class="py-0">
                      <v-text-field
                        v-model.trim="num_doc_depositante"
                        outlined
                        dense
                        label="C.I. de Depositante"></v-text-field>
                    </v-col>
                    <template v-if="forma && forma.id == 2">
                      <v-col cols="4" class="py-0">
                        <v-select
                          v-model="cuenta"
                          :items="cuentas_bancarias"
                          item-text="nombre"
                          outlined
                          dense
                          :rules="fieldRules"
                          label="N° de Cuenta Bancaria"
                          return-object></v-select>
                      </v-col>
                      <v-col cols="4" class="py-0">
                        <v-text-field
                          v-model="numero_deposito"
                          :rules="fieldRules"
                          outlined
                          dense
                          label="N° Comprobante/Bancarizacion/deposito"
                          hint="Numero de comprobante/Bancarizacion/deposito de la tranferencia realizado en la entidad bancaria o Tigo Money."></v-text-field>
                      </v-col>
                    </template>
                  </v-row>
                </v-sheet>
                <!-- =======secction cobros programa======= -->
                <div vv-if="tipo_facturacion">
                  <p class="text-center mb-0"><b>Programa con NIT: </b> {{ tipo_facturacion }}</p>
                </div>

                <v-row no-gutters v-show="nitelectronico">
                  <!-- <v-col cols="12" sm="4" md="6">
                    <v-select
                      v-model="actividad"
                      :items="uactividades"
                      :loading="loadingactividades"
                      return-object
                      label="Actividad"
                      class="mr-2 mt-6"
                      outlined
                      dense
                      hide-details
                    />
                  </v-col> -->
                  <v-col cols="12" sm="4" md="6">
                    <v-select
                      v-model="docsector"
                      :items="docssector"
                      label="Documento Sector"
                      :disabled="loadingactividades"
                      item-value="id"
                      class="mt-6"
                      outlined
                      dense
                      hide-details />
                  </v-col>
                </v-row>

                <v-row
                  v-if="
                    existsPlanPagos &&
                    plan_inscripcion &&
                    plan_inscripcion.aprobado &&
                    programa.estado_inscripcion &&
                    programa.estado_plan_id &&
                    !isbenitojuarez
                  ">
                  <v-col cols="12" sm="5" md="5" lg="5">
                    <v-text-field
                      v-if="!nitelectronico || docsector"
                      type="number"
                      v-model.number="monto_cancelar"
                      outlined
                      dense
                      label="Monto a cancelar (use punto para decimales)"
                      background-color="#ffe17694"
                      :rules="[rules.loanMin]"
                      placeholder="0"
                      @keyup="autoLoadItems"
                      hide-details>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="7" md="7" lg="7" class="pa-2 text-center">
                    <p class="font-weight-bold my-0">
                      Estudiante inscrito con el plan:
                      <v-btn text class="text-decoration-underline mx-2" @click="openShowViewPlan">{{
                        plan_inscripcion.nombre
                      }}</v-btn>
                      <v-btn v-if="!existRecibo" color="info" small @click="generatePlan(true)">
                        <v-icon class="mr-1">mdi-sync</v-icon> Cambiar de plan
                      </v-btn>
                    </p>
                  </v-col>
                </v-row>
                <!-- =======tables======= -->
                <v-row
                  v-if="
                    existsPlanPagos &&
                    plan_inscripcion &&
                    plan_inscripcion.aprobado &&
                    programa.estado_inscripcion &&
                    programa.estado_plan_id
                  ">
                  <v-col cols="12" sm="12" xl="6" md="4" lg="6" class="py-0">
                    <v-progress-linear
                      v-if="loadingkardex"
                      indeterminate
                      color="green"
                      class="darken-4"
                      height="4"></v-progress-linear>

                    <div v-if="!nitelectronico || docsector">
                      <v-data-table
                        v-if="!isbenitojuarez && (docsector == 11 || !docsector || docsector == 46)"
                        :headers="headers"
                        :items="plan_pagos"
                        class="elevation-10"
                        hide-default-footer
                        disable-pagination>
                        <template v-slot:top>
                          <p class="h3 text-center pt-2 text-primary">CUOTAS POR PAGAR </p></template
                        >
                        <template v-slot:item="{ item }">
                          <tr
                            :title="item.descuento > 0 ? `Descuento: ${item.descuento} ` : ''"
                            :class="itemRowBackgroundMora(item)">
                            <td>{{ item.concepto }}</td>
                            <td>{{ item.numero_cuota }}</td>
                            <td>{{ item.monto }}</td>
                            <td>{{ item.saldo }}</td>
                            <td>{{ item.date_pago }}</td>
                            <td>
                              <v-tooltip top v-if="item.bloqueado">
                                <!-- Corregir esta parte los bloqueados no estan segun el orden -->
                                <template #activator="{ on, attrs }">
                                  <v-icon v-if="item.saldo" v-bind="attrs" v-on="on" color="gray"
                                    >mdi-plus-circle-outline</v-icon
                                  >
                                </template>
                                Pago pendiendo por otro Medio
                              </v-tooltip>
                              <v-btn icon v-else>
                                <v-icon v-if="item.saldo && item.canAdd" color="success" @click="addItems(item)"
                                  >mdi-plus-circle-outline</v-icon
                                >
                              </v-btn>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>

                      <v-data-table
                        :headers="headersOptional"
                        :items="pagos_opcionales"
                        cv-if="docsector == 1 || !docsector"
                        class="elevation-10"
                        hide-default-footer
                        disable-pagination>
                        <template v-slot:top>
                          <p class="h3 text-center pt-2 orange--text text-decoration-underline">
                            {{ isbenitojuarez ? 'PAGOS NACIONALES' : 'PAGOS OPCIONALES' }}
                          </p></template
                        >
                        <template v-slot:[`item.options`]="{ item }">
                          <v-icon v-if="item.saldo" class="ma-2" color="orange" @click="addItems(item)"
                            >mdi-plus-circle</v-icon
                          >
                        </template>
                      </v-data-table>
                    </div>
                  </v-col>
                  <v-col v-if="!!items.length" cols="12" xl="6" :md="existsPlanPagos ? 8 : 12" lg="6" class="py-0">
                    <v-data-table
                      :headers="headersItems"
                      :items="items"
                      class="elevation-10"
                      hide-default-footer
                      disable-pagination>
                      <template v-slot:top> <p class="h3 text-center pt-2 text-primary">ITEMS DE RECIBO:</p></template>
                      <!-- <template v-slot:[`item.concepto`]="{ item }">
                        <v-text-field :disabled="!item.optional" v-model="item.concepto" class="ma-2" outlined dense :rules="fieldRules"></v-text-field>
                      </template> -->
                      <template v-slot:[`item.cantidad`]="{ item }">
                        <v-text-field
                          v-if="is_cas || item.optional"
                          :disabled="!item.editable"
                          :readonly="isbenitojuarez"
                          type="number"
                          v-model.number="item.cantidad"
                          @input="updatesubtotal(item)"
                          outlined
                          dense
                          :max="100"></v-text-field>
                        <p v-else>{{ item.cantidad }}</p>
                      </template>
                      <template v-slot:[`item.monto`]="{ item }">
                        <small>
                          <!-- > {{ is_cas }}, {{ item.optional }}, {{ item.es_monto_modificable }} *
                          {{ (!is_cas && !item.optional) || item.es_monto_modificable }} -->
                        </small>
                        <v-text-field
                          v-if="(!is_cas && !item.optional) || item.es_monto_modificable"
                          :disabled="!item.editable"
                          :readonly="isbenitojuarez"
                          type="number"
                          v-model.number="item.monto"
                          outlined
                          dense
                          @input="updatesubtotal(item)"
                          @change="updateTotal"
                          :rules="[rules.required, rules.loanMin, rules.loanMax(item.monto, item.saldo)]"
                          :max="item.saldo"></v-text-field>
                        <p v-else>{{ item.monto }}</p>
                      </template>
                      <template v-slot:[`item.subtotal`]="{ item }">
                        <p>{{ item.subtotal }}</p>
                      </template>
                      <template v-slot:[`item.umedida`]="{ item }">
                        <p>{{ item.unidad_medida_abreviatura }}</p>
                      </template>
                      <template v-slot:[`item.options`]="{ item }">
                        <v-icon v-if="item.editable || item.optional" class="ma-2" color="red" @click="removeItem(item)"
                          >mdi-delete-alert</v-icon
                        >
                      </template>
                      <template v-slot:footer>
                        <v-row justify="center" class="mx-2">
                          <v-col md="4" sm="6" xl="12">
                            <v-text-field v-model="total" outlined dense readonly :label="`TOTAL (${montostr})`"></v-text-field
                          ></v-col>
                        </v-row>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
                <p v-else class="text-center red--text font-weight-bold ma-2">
                  El estudiante no tiene plan de pagos o no esta aprobado, nose puede emitir recibo
                </p>
              </template>
            </div>

            <div v-if="!is_factura_directo">
              <p class="text-center mt-4 mb-0"><b>Facturacion directa: </b> {{ is_factura_directo ? 'SI' : 'NO' }}</p>
            </div>

            <p class="my-0 text-center">
              <b>{{ msgnofact }}</b>
            </p>

            <div v-if="nitelectronico" v-show="docsector != null && items.length > 0">
              <p class="mt-6"></p>
              <FacturaE
                v-show="is_factura_directo && msgnofact == ''"
                ref="facturaelectro"
                v-on:onfacturagenerada="onfacturagenerada"
                v-on:onfacturafalled="onfacturafalled"
                v-on:xloadstatusconceptos="onloadallconceptos" />
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              :loading="enviando"
              color="success"
              v-if="existsPlanPagos && plan_inscripcion.aprobado && items.length"
              rounded>
              <v-icon class="mr-1"> mdi-content-save</v-icon> Guardar Datos
            </v-btn> 
            <v-btn v-if="is_upi" color="orange darken-1" dark rounded @click="open_duplicar_in_q10" title="duplicar estudiante en el Q10">
              Q10 <v-icon> mdi-open</v-icon>
            </v-btn>
            <v-btn color="blue darken-1" outlined rounded @click="closeDialog">
              Cancelar <v-icon> mdi-close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <print-facturae ref="refFacturaePrint" @fanulada="fanulada" v-on:anuladofact="anuladofact" />
    <insert-code-program ref="refAddCodeProgram" @clickedAddCode="clickedAddCode"></insert-code-program>
    <aprobar-plan
      ref="refAprobarPlan"
      @clickedAprobePlan="eventAprobe"
      @generatePlan="generatePlan"
      :programa="programa"
      :existRecibo="existRecibo">
    </aprobar-plan>
    <aprobar-plan-ins
      ref="refAprobarPlanIns"
      @clickedAprobe="eventAprobeIns"
      @deletePlan="deletePlan"
      :programa="programa"
      :existRecibo="existRecibo">
    </aprobar-plan-ins>
    <view-plan ref="refViewPlan"></view-plan>
    <ARazones ref="arazones" />
    <facturae-view ref="refEmitFacturae" />
    <comprobar ref="refcomprobar" v-on:success="()=>{}"/>
    <modal_propuesta_duplicar ref="refmodal_propuesta_duplicar" />
  </v-row>
</template>

<script>
  import gql from 'graphql-tag';
  import AprobarPlan from './AprobarPlan';
  import AprobarPlanIns from './AprobarPlanIns';
  import ViewPlan from './ViewPlan';
  import InsertCodeProgram from './InsertCodeProgram';
  import ARazones from '@/components/ARazonesrecibos.vue';
  import FacturaE from '@/views/recibos/EmitFacturaEViewform.vue';
  import FacturaeView from './EmitFacturaEView.vue';
  import PrintFacturae from './PrintFacturae.vue';
  import CobranzaService from '../verificar/cobranzasService';
  import comprobar from '@/views/nominaciones/cajas/comprobar.vue';
  import xaxios from '@/xaxios';
  import modal_propuesta_duplicar from '../upi/modal_propuesta_duplicar.vue';
import { concepto_ids_orden } from '../upi/planes/utils';

  export default {
    components: {
      AprobarPlanIns,
      AprobarPlan,
      ViewPlan,
      InsertCodeProgram,
      ARazones,
      FacturaE,
      FacturaeView,
      PrintFacturae,
      comprobar,
      modal_propuesta_duplicar,
    },
    data() {
      return {
        is_cas: false,
        tipo_facturacion: '',
        tipo_facturacionTxt: '',
        nitelectronico: false,
        loadingactividades: false,
        xsucursal: null,
        cobranzaService: new CobranzaService(),
        plataforma: {},
        // noFacturables: [],
        rules: {
          required: (value) => !!value || 'Se requiere un monto a pagar',
          loanMin: (value) => value >= 0 || 'Monto debe ser mayor a 0',
          loanMax: (monto, saldo) => monto <= saldo || 'Monto no puede ser mayor al saldo de ' + saldo,
          ifSucursal: (v, p) => (v ? p && p.ifSucursalId : true) || 'El Programa no tiene Nit, No podra emitir factura',
          requiredItems: (v, items) => {
            if (v && items.length <= 0) return 'Debe haber al menos un items facturable para emitir factura';
            return true;
          },
          facturaItems: (v, items) => {
            let facturable = true;
            if (v && items.length) {
              items.forEach((t) => {
                if (!t.facturable) {
                  facturable = false;
                  return;
                }
              });
            }
            return facturable || 'Un items no es facturable';
          },
        },
        menu_name: process.env.VUE_APP_NAME_MENU,
        api_rest: process.env.VUE_APP_API_REST,
        dialog: false,
        existRecibo: false,
        valid: false,
        total: 0,
        monto_cancelar: 0,
        enviando: false,
        fieldRules: [(v) => !!v || 'Campo Obligatorio'],
        //   ----Datos Recibo----
        fecha_pago: null,
        date: new Date().toISOString().substr(0, 10),
        nombre_depositante: null,
        num_doc_depositante: null,
        num_factura: null,
        con_factura: false,
        msgprogs: '',
        msgnofact: '',
        //   ----student-----
        inscripcion: null,
        persona: null,
        searchPersona: '',
        searchingpersona: false,
        isbenitojuarez: false,
        personas: [],
        //   ----program-----
        programa: null,
        programas: [],
        //   ----cuentas_bancarias-----
        cuenta: null,
        cuentas_bancarias: [],
        numero_deposito: null,
        //   ----formas_pago de pago-----
        forma: null,
        formas_pago: [],
        /* formas_pago: [
          //FIXME: this array is static
          { id: 1, nombre: 'Efectivo', descripcion: 'Pago realizado con dinero efectivo' },
          {
            id: 2,
            nombre: 'Transferencia - Depósito - Tigo Money',
            descripcion: 'Trasferencia realizada a travez de Tigo Money o entidad Bancaria',
          },
        ], */
        //   ----planes pagos  de programa-----
        existsPlanPagos: false,
        plan_pagos: [],
        pagos_opcionales: [],
        plan_inscripcion: null,
        //   ----items-----
        headers: [
          { text: 'Concepto', value: 'concepto' },
          { text: 'N° Cuota', value: 'numero_cuota' },
          { text: 'Monto', value: 'monto' },
          { text: 'Saldo', value: 'saldo' },
          { text: 'Fecha Pago', value: 'date_pago' },
          { text: 'Añadir', value: 'options', sortable: false, width: 40 },
        ],
        headersItems: [
          { text: 'Concepto de pago', value: 'concepto' },
          { text: 'N° Cuota', value: 'numero_cuota', width: 40 },
          { text: 'Cantidad', value: 'cantidad', width: 50 },
          { text: 'Monto', value: 'monto' },
          { text: 'Subtotal', value: 'subtotal' },
          { text: 'Un. Medida', value: 'umedida' },
          { text: 'Remover', value: 'options', sortable: false, width: 100 },
        ],
        headersOptional: [
          { text: 'Concepto', value: 'concepto' },
          { text: 'Monto', value: 'monto' },
          { text: 'Añadir', value: 'options', sortable: false, width: 120 },
        ],

        items: [],
        menu1: false,
        loadingkardex: false,
        loadingprogramas: false,
        loadingformas: false,
        sedeid_benitojuarez: 19,
        razonestxt: '',
        xreciboelectro: null,
        uactividades: [],
        docssector: [
          { id: 1, text: 'COMPRA Y VENTA' },
          { id: 11, text: 'SECTOR EDUCATIVO' },
          { id: 46, text: 'SECTOR EDUCATIVO ZONA FRANCA' },
        ],
        docsector: null,
        actividad: null,
        xloadstatusconceptos: false,
        is_upi: false,
      };
    },
    computed: {
      is_factura_directo() {
        if (!this.xsucursal) return false;
        return this.xsucursal.is_directo;
      },
      montostr(){  
        const un = this.$store.state.CARGO.sede.unidad_negocio
          if( un == 15 ) return '$' 
        return 'Bs.'
      }
    },
    watch: {
      '$route.name': function () {
        this.isbenitojuarez = location.href.includes('recibosbenito');
      },
      actividad: function (a) {
        if (!this.actividad) return;
        this.docsector = null;
        if (a.codigo == '620200') this.docsector = 1;
        else if (a.codigo == '853000') this.docsector = 11;
        else this.docsector = 46;
      },
      docsector() {
        if (this.docsector) {
          this.$refs.facturaelectro.verificarCafcActivo(this.docsector);
        }
      },
      searchPersona(query = null) {
        this.getFormasdePago();
        if (query && query.length > 3) {
          let sql = gql`query{ getPersonasSearchNameOrNumDoc(text:"${query}",cursor: 10000000, estado: true){id num_doc nombres pri_apellido seg_apellido usuario_moodle } }`;
          this.searchingpersona = true;
          this.personas = [];
          let vue = this;
          this.$apollo.query({ query: sql }).then(({ data }) => {
            window.console.log('dataaa>>',data.getPersonasSearchNameOrNumDoc);
            
            vue.searchingpersona = false;
            vue.personas = data.getPersonasSearchNameOrNumDoc;
            vue.personas && this.personas.length > 0
              ? this.personas.map(
                  (item) =>
                    (item.nombres = `${item.nombres} ${item.pri_apellido} ${
                      item.seg_apellido ? item.seg_apellido : ''
                    }`),
                )
              : null;
          });
        } else {
          this.personas = [];
          this.persona = null;
          this.programa = null;
          this.searchingpersona = false;
          this.nitelectronico = false;
        }
      }, 
      /* searchPersona(query = null) {
        this.getFormasdePago();
        if (query && query.length > 3) {
          let sql = gql`query{ getPersonasByName(nombres:"${query}"){id num_doc nombres pri_apellido seg_apellido usuario_moodle } }`;
          if (/^\d+$/.test(+query) || query.includes('-'))
            sql = gql`query{ getPersonasByDoc(num_doc:"${query}", estado:true){id num_doc nombres pri_apellido seg_apellido usuario_moodle  } }`;
          this.searchingpersona = true;
          this.personas = [];
          let vue = this;
          this.$apollo.query({ query: sql }).then(({ data }) => {
            vue.searchingpersona = false;
            vue.personas = data && data.getPersonasByName ? data.getPersonasByName : data.getPersonasByDoc;
            vue.personas && this.personas.length > 0
              ? this.personas.map(
                  (item) =>
                    (item.nombres = `${item.nombres} ${item.pri_apellido} ${
                      item.seg_apellido ? item.seg_apellido : ''
                    }`),
                )
              : null;
          });
        } else {
          this.personas = [];
          this.persona = null;
          this.programa = null;
          this.searchingpersona = false;
          this.nitelectronico = false;
        }
      }, */
      persona(value) {
        value && value.id ? this.getProgramas(value.id) : null;
      },
      programa(value) {
        if (!value) return;
        // window.console.log('value:::', value);
        this.getsucursal(value.sucursal_id);
        this.getkardex(value.id);
        //window.console.log('PROGRAMA::: ', JSON.stringify(value, null, 4));

        this.con_factura = false;
        this.existRecibo = false;
        this.monto_cancelar = 0;
        this.plan_inscripcion = null;
        // si existe cuotas agregados para pagar, entoces deeemos devolverlos al plan de pagos
        if (this.items.length > 0) {
          this.items.forEach((item) => {
            // item.subtotal = 0; // nuevo
            // item.cantidad = 0; // nuevo
            if (!item.optional) {
              item.monto = item.pago;
              this.plan_pagos.push(item);
            }
          });
        }
        this.loadConceptosOptionals();
        this.existsPlanPagos = value && value.plan_pagos && value.plan_pagos.length ? true : false;

        if (this.existsPlanPagos) {
          this.plan_inscripcion = value.planes[0];
          // descomentar todo esto y ya no llamar al kardex..
          /*this.plan_pagos = value.plan_pagos.map((pp) => ({
            ...pp,
            date_pago: this.formatDate(pp.fecha_pago),
            concepto_id: pp.concepto_pago_id,
            pago: pp.monto,
            editable: true, / FIXME: variable en obs
            canAdd: true, // FIXME: variable en obs
            optional: false,
          }));

          this.plan_pagos.forEach((plan) => {
            if (plan.monto != plan.saldo) {
              this.existRecibo = true;
              return;
            }
          });
          this.fieldCanAdd();*/
        }else{
          this.plan_inscripcion = {};
        }
        // this.openConfirmDialogAprobe();
        // this.items = [];
      },
      date() {
        this.fecha_pago = this.formatDate(this.date);
      },
      forma() {
        this.getCuentasBancarias(this.$store.state.CARGO.sede.id);
      },
      dialog(val) {
        this.nitelectronico = false;
        this.xsucursal = null;
        // this.noFacturables = []; 
        this.msgnofact = '';
        val || this.closeDialog(); 
      },
      items: {
        deep: true,
        handler(a) {
          this.msgnofact = '';
          // window.console.log('items', a);
          let vue = this;
          a.forEach((x) => {
            // window.console.log('itemssss', x);
            if (!x.facturable)
              vue.msgnofact = `AVISO: No podra emitir factura porque el concepto: '${x.concepto}' No es facturable.`;
          });
        },
      },
    },
    methods: {
      async getkardex(idinscripcion) {
        //this.getSedes();
        this.loadingkardex = true;
        this.actividad = null;
        this.xloadstatusconceptos = false;
        this.getPlataformas();
        if(!this.plan_inscripcion) this.plan_inscripcion = {};
        // window.console.log('plan_inscripcioaaan',this.plan_inscripcion);
        // this.noFacturables = [];
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${idinscripcion}/plan-pago/kardex`;
        await xaxios.get(url).then(({ data }) => {
          // window.console.log('KARDEX:', data.data);

          vue.plan_pagos = data.data.map((plan) => ({
            ...plan,
            monto: plan.total,
            cantidad: 1, // nuevo
            subtotal: 0, // nuevo
            //descuento: plan.descuento.toFixed(2),
            // saldo: parseInt(plan.saldo * 100) / 100,
            // saldo: parseFloat(plan.saldo.toFixed(2)),
            saldo: parseFloat(plan.saldo),
            concepto: plan.concepto_pago,
            numero_cuota: plan.nro_cuota,

            date_pago: this.formatDate(plan.fecha_pago),
            concepto_id: plan.concepto_pago_id,
            // pago: plan.total.toFixed(2),
            pago: plan.total,
            editable: true, // FIXME: variable en obs
            canAdd: true, // FIXME: variable en obs
            optional: false,
            es_monto_modificable: false,
          }));

          vue.plan_pagos.forEach((plan) => {
            if (plan.monto != plan.saldo) {
              vue.existRecibo = true;
              return;
            }
          });
          vue.loadingkardex = false;
          vue.fieldCanAdd();

          vue.openConfirmDialogAprobe();
          vue.items = [];
          vue.verificar_is_upi();
          //window.console.log(JSON.stringify(vue.plan_pagos, null, 4));
        });
      },
      async getPlataformas() {
        const res = await this.cobranzaService.getOnlyPlataformas(this, (data) => data);
        this.plataforma = res.find((p) => p.id == this.programa.plataforma_id);
        //let a = 2;
        if (!this.plataforma /*  && a == 45 */) {
          const msg = `NOTA: El programa no tiene asignado una Plataforma Moodle el desbloqueo automatico del modulo no se podra realizar despues de generar el recibo`;
          this.$root.$notify.show(msg, {
            color: 'orange',
            x: 'right',
          });
        }
      },
      getGMTMinus4Date() {
        const date = new Date();
        const gmtMinus4Date = new Date(date.getTime() - (4 * 60 * 60 * 1000));
        return gmtMinus4Date.toISOString().substr(0, 10);
      },
      getsucursal(idsucursal) {
        //window.console.log(">>>>> xxx", idsucursal);
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        if(unidad != 10 ){ // !dbs
          this.docssector = this.docssector.filter(x=>x.id != 46);
        }else {
          this.docssector = this.docssector.filter(x=>x.id != 46)
          this.docssector.push( { id: 46, text: 'SECTOR EDUCATIVO ZONA FRANCA' } );
        }

        this.tipo_facturacionTxt = '';
        // window.console.log('getsucursal idsucursal:', idsucursal);
        if (!idsucursal)
          this.$root.$notify.show(`El programa no tiene asignado una sucursal.`, { color: 'danger', x: 'left' });
        this.tipo_facturacion = '';
        this.nitelectronico = false;
        this.loadingVerifMasivo = false;
        this.docsector = null;
        this.xsucursal = null;
        let idnegocio = this.$store.state.CARGO.sede.unidad_negocio;

        const vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${idsucursal}`,
          headers: {
            'Content-Type': 'application/json',
          },
        };

        // window.console.log("AQQQQUUUU PODRIA FALLAR");
        xaxios.request(config)
          .then(function (response) {
            vue.xsucursal = response.data;
            // window.console.log('xsucursal:::::::::', vue.xsucursal);
            vue.tipo_facturacion = response.data.tipo_facturacion;
            vue.tipo_facturacionTxt = response.data.tipo_facturacion;
            if ((vue.tipo_facturacion + '').includes('ELECTR')) {
              vue.nitelectronico = true;
              vue.getactividades();
              setTimeout(() => {
                vue.$refs.facturaelectro.setParametros({ showfooter: false });
                vue.$refs.facturaelectro.setLoadPuntosBySucursal(idsucursal, vue.xsucursal);
              }, 1000);
            }
          })
          .catch(function (error) {
            window.console.log(error.response);
            if (idnegocio != 1) {
              vue.tipo_facturacion = 'No hay sucursal';
            }
          });
      },
      getactividades() {
        this.loadingactividades = true;
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/catalogo/actividad`,
          headers: {
            apikey: this.$store.getters.getApiKey,
          },
        };

        // window.console.log("AQQQQUUUU PODRIA FALLAR2222");
        xaxios.request(config)
          .then(function (response) {
            // window.console.log('getactividades',response);
            let data = response.data;
            data.map((u) => {
              u.id = u.codigo;
              u.text = `(${u.codigo}) ${u.descripcion}`;
            });
            vue.uactividades = data;
            let defecto = data.find((x) => x.codigo == '853000');
            vue.actividad = defecto;
            vue.loadingactividades = false;
          })
          .catch(function (error) {
            window.console.log(error);
            vue.loadingactividades = false;
          });
      },
      itemRowBackgroundMora(item) {
        if (item.descuento > 0) {
          return 'descuento';
        }
        let fecha_pago = new Date(item.fecha_pago);
        fecha_pago.setDate(fecha_pago.getDate() + 1);

        let fecha_mes = new Date(item.fecha_pago);
        fecha_mes.setMonth(fecha_mes.getMonth() + 1);

        if (fecha_mes < new Date() && item.saldo != 0) return 'mora-mes-1';
        if (fecha_pago < new Date() && item.saldo != 0) return 'mora-semana-1';
        return item.saldo_regularizado ? 'regularizado' : '';
      },
      generatePlan(value) {
        //window.console.log(this.programa, this.inscripcion);
        const idsede = this.$store.state.CARGO.sede.id 
        const contiene_avd = this.programa.nombre_compuesto.includes('U301 AVANZADO)')
        window.console.log('contiene_avd', contiene_avd);
        
        if(idsede == 82 && contiene_avd ){
          const u = `/generar_plan_upi/${this.programa.programa_id}?ins_id=${this.programa.id}&asesor_id=${this.programa.asesor_id}&doc=${this.persona.num_doc}&cambio_plan=true`;
          this.$router.push(u);
          return;
        }
        
        var inss = {
          id: this.programa.id,
          estudiante: { id: this.programa.estudiante_id },
          asesor: { id: this.programa.asesor_id },
        };
        this.$store.dispatch('inscripcion/selectInscripcion', inss); // no se porque programa.id pero es el idinscripcion
        if (this.programa.estado_inscripcion == 0) {
          this.cambiarinscrito(inss);
          return;
        }
        this.$refs.refAprobarPlan.closeDialog();
        let programa = Object.assign(
          {
            programa: { id: this.programa.programa_id },
            estudiante: { id: this.programa.estudiante_id },
            asesor: { id: this.programa.asesor_id },
          },
          this.programa,
        );

        window.sessionStorage.setItem('xinscritotoplan', JSON.stringify(programa));
        window.sessionStorage.setItem(
          'xprograma',
          JSON.stringify({
            id: programa.programa_id,
            codigo: programa.nombre_compuesto,
            inscripcion_id: this.programa.id,
            plan_pagos: this.plan_pagos,
            estudiante_estado: this.programa.estado_inscripcion,
            estudiante_id: this.programa.estudiante_id,
          }),
        );
        value ? this.$router.push({ name: 'inscripcionrest' }) : this.$router.push({ name: 'regularizar' });
        this.closeDialog();
      },
      cambiarinscrito(ins) {
        //this.$store.dispatch('inscripcion/selectInscripcion', ins);
        window.console.log('jejej', this.programa);
        let xpro = window.Object.assign({}, this.programa);
        xpro.id = xpro.programa_id;
        xpro.inscripcion_id = ins.id;
        xpro.estudiante_id = ins.estudiante.id;
        window.sessionStorage.setItem('xprograma', JSON.stringify(xpro));
        window.sessionStorage.setItem('xpreinscrito', JSON.stringify(ins));
        this.$router.push({ name: 'inscripcionrest' });
      },
      openregistrarCaja(item=null){
        this.$refs.refcomprobar.openmodal(item);
      },

      loadConceptosOptionals() {
        let url = `${this.api_rest}/api/pagos/conceptos/buscar`;
        let datasend = { unidad_negocio_id: this.$store.state.UNIDAD_NEGOCIO_ID };
        if (this.isbenitojuarez) {
          datasend.es_nacional = true;
        } else {
          datasend.es_nacional = false;
        }
        xaxios
          .post(url, datasend)
          .then(({ data }) => {
            window.console.log('buscar opcionales....', data);
            data = data.filter((concepto) => concepto.opcional && concepto.estado);
            data = data.map((concepto, i = 0) => ({
              ...concepto,
              index: ++i,
              concepto_id: concepto.id,
              concepto: concepto.nombre,
              saldo: concepto.monto,
              numero_cuota: 1,
              optional: true,
              // es_monto_modificable: true,
              editable: true,
              canAdd: true,

              cantidad: 1, // nuevo
              subtotal: 0, // nuevo
            }));
            this.pagos_opcionales = data;
          })
          .catch(() => this.$root.$notify.show(`No se logró cargar los datos opcionales`, { color: 'primary' }));
      },
      showHint(persona) {
        return persona ? `${persona.nombres ? persona.nombres : ''} - ${persona.num_doc ? persona.num_doc : ''}` : '';
      },
      async openShowViewPlan() {
        let inscripcion = await this.get_data_inscripcion(this.programa.id);
        this.$refs.refViewPlan.showThisView(inscripcion);
      },
      get_data_inscripcion(id) {
        const sql = gql`query{ getInscripcion(id:${id}){
            id,idprograma,idestudiante,estado_ins,observaciones,idasesor,fecha_registro,registrado_por,tipopago,puede_cambiar
            estado_plan_cobro_programa,aprobado_plan_cobro_programa_user_id
            # asesor {id nombres pri_apellido seg_apellido}
            estudiante {id num_doc nombres pri_apellido seg_apellido domicilio telefono1 telefono2 email fecha_nac contacto estado}
            programa {nombre_compuesto, universidad{id,nombre}}
            plan_programa {id nombre aprobado, cobros_programa{ id monto cuotas estado concepto_pago{id nombre} }}
            plan_pagos { id monto saldo nro_cuota descuento fecha_pago bloqueado saldo_regularizado concepto_pago{id nombre}}
            # pagos_inscripcion {}
        }}`;
        return this.$apollo
          .query({ query: sql })
          .then(({ data }) => data.getInscripcion)
          .catch(() => {
            this.$root.$notify.show(`No de puede cargar el detalle`, { color: 'info' });
            return {};
          });
      },

      openConfirmDialogAprobe() {
        if(!this.plan_inscripcion) this.plan_inscripcion = {};
        window.console.log('plan_inscripcion',this.plan_inscripcion);
        if (this.programa && !this.programa.ifcode) {
          this.openAddCodeDialog();
        } else {
          if (this.programa && this.programa.estado_inscripcion && this.plan_inscripcion) {
            if (!this.plan_inscripcion.aprobado) {
              !this.plan_inscripcion.aprobado ? this.openAprobarPlanShow() : null;
            } else {
              !this.programa.estado_plan_id ? this.openShowAprobarPlanIns() : null;
            }
          }
        }
      },
      openAddCodeDialog() {
        this.$refs.refAddCodeProgram.showThisView(this.programa.programa_id, this.programa);
      },
      clickedAddCode({ value, code }) {
        if (this.programa && value) {
          this.programa.codigo = code;
          this.programa.ifcode = true;
          this.$root.$notify.show(`Codigo: ${code} agregado correctamente al programa.`, { color: 'success' });
        } else {
          this.$root.$notify.show(`No se puede añador el codigo de programa.`, { color: 'red' });
        }
        this.openConfirmDialogAprobe();
      },
      openAprobarPlanShow() {
        this.$refs.refAprobarPlan.showThisView(this.plan_inscripcion);
      },
      eventAprobe(value) {
        if (this.plan_inscripcion && value) {
          this.plan_inscripcion.aprobado = value;
          this.$root.$notify.show(`${this.plan_inscripcion.nombre} Aprobado correctamente.`, { color: 'success' });
          !this.programa.estado_plan_id ? this.openShowAprobarPlanIns() : null;
        } else {
          this.$root.$notify.show(
            `${this.plan_inscripcion.nombre}, No fue aprobado, por tanto nose puede emitir recibo`,
            {
              color: 'red',
              timeout: 5000,
              x: 'left',
            },
          );
          this.$refs.refAprobarPlanIns.closeDialog();
        }
      },
      openShowAprobarPlanIns() {
        this.$refs.refAprobarPlanIns.showThisView(this.plan_inscripcion, this.plan_pagos, this);
      },
      eventAprobeIns({ estado_plan_id, aprobado_plan_user_id }) {
        if (estado_plan_id) {
          this.programa.estado_plan_id = estado_plan_id;
          this.programa.aprobado_plan_user_id = aprobado_plan_user_id;
          this.$root.$notify.show(`${this.plan_inscripcion.nombre} Aprobado correctamente.`, { color: 'success' });
        } else {
          this.$root.$notify.show(`Plan de pagos no aprobado.`, { color: 'red' });
        }
        this.plan_inscripcion && !this.plan_inscripcion.aprobado && this.programa.estado_inscripcion
          ? this.openAprobarPlanShow()
          : null;
      },
      deletePlan(value) {
        if (value) {
          this.programa.plan_pagos = [];
          this.programa.estado_plan_id = false;
        }
      },
      autoLoadItems() {
        for (let i = this.items.length; i > 0; i--) {
          const element = this.items[0];
          element && !element.optional ? this.removeItem(element) : null;
        }

        //this.monto_cancelar = parseFloat(this.monto_cancelar);
        let incluye = (this.monto_cancelar + '').includes('.');
        let termina = (this.monto_cancelar + '').endsWith('.');
        if (incluye && !termina) this.monto_cancelar = Math.round((this.monto_cancelar + Number.EPSILON) * 100) / 100;

        let auxArray = this.plan_pagos.filter((item) => item.saldo > 0 && !item.optional);
        let monto = parseFloat(this.monto_cancelar);

        for (let i = auxArray.length; i > 0; i--) {
          let firstElement = auxArray.shift();
          if (monto > 0 && firstElement.saldo > 0) {
            //codigo wilver
            //this.addItems(firstElement, monto >= firstElement.saldo ? firstElement.saldo : monto);
            let xmonto = monto >= 0 && monto < firstElement.saldo ? monto : firstElement.saldo;
            //window.console.log(firstElement.saldo, monto, xmonto);
            this.addItems(firstElement, xmonto);
            //codigo wilver
            //monto = monto - (monto >= firstElement.saldo ? firstElement.saldo : monto);
            //window.console.log(firstElement.saldo, monto, xmonto);
            //mi codigo
            monto -= xmonto;
            monto = parseFloat(monto);
          }
        }
        //window.console.log(this.items);
      },
      formatDate(date) {
        if (!date) return null;
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      },
      fieldEditable() {
        if (this.existsPlanPagos) {
          this.items.sort((a, b) => {
            if (a.concepto_id == b.concepto_id) {
              if (a.numero_cuota > b.numero_cuota) {
                b.editable = false;
                a.editable = true;
                // DESCOMENTADO DE WILVER A VER SI FUNCIONA
                //b.monto = b.saldo;
              } else {
                a.editable = false;
                b.editable = true;
                //a.monto = a.saldo;
              }
            } else {
              if (this.items.length <= 2) {
                a.editable = true;
                b.editable = true;
              }
            }
            return a.concepto_id - b.concepto_id || a.numero_cuota - b.numero_cuota;
          });
          if (this.items.length === 1) {
            this.items[0].editable = true;
          }
        }
      },
      fieldCanAdd() {
        if (this.existsPlanPagos) {
          let idnegocio = this.$store.state.CARGO.sede.unidad_negocio;
          //window.console.log('unidad negocio:::',idnegocio);
          if (idnegocio == 1) {
            // FOR ESAM
            let pila = [];
            this.plan_pagos.sort((a, b) => {
              return a.concepto_id - b.concepto_id || a.numero_cuota - b.numero_cuota;
            });
            this.plan_pagos.forEach((p) => {
              p.canAdd = false;
              let existe = pila.find((x) => x.concepto_id == p.concepto_id);
              if (!existe && p.saldo > 0 && pila.length == 0) {
                // quitar pila.length para poder pagar por cada concepto
                p.canAdd = true;
                pila.push(p);
              }
            });
          } else if(idnegocio == 10){
            // FOR DBS primero cuota inicial 133
            let pila = [];
            this.plan_pagos.sort((a, b) => {
              const order = [133, 1, 2, 3, 4, 5]; // Orden personalizado de los estados
              const estadoA = a.concepto_id;
              const estadoB = b.concepto_id;
              const indexA = order.indexOf(estadoA);
              const indexB = order.indexOf(estadoB);

              return indexA - indexB || a.numero_cuota - b.numero_cuota; 
            });
            this.plan_pagos.forEach((p) => {
              p.canAdd = false;
              let existe = pila.find((x) => x.concepto_id == p.concepto_id);
              if (!existe && p.saldo > 0 && pila.length == 0) {
                // quitar pila.length para poder pagar por cada concepto
                p.canAdd = true;
                pila.push(p);
              }
            });

            
          }else if (idnegocio == 15){
            const prioridad = new Map(
              concepto_ids_orden.map((id, index) => [id, index])
            );
            /* this.plan_pagos.sort((a, b) => {
              return (prioridad.get(a.concepto_id) ?? Infinity)
                  - (prioridad.get(b.concepto_id) ?? Infinity);
            }); */
            this.plan_pagos.sort((a, b) => {
              const prioridadA = prioridad.get(a.concepto_id) ?? Infinity;
              const prioridadB = prioridad.get(b.concepto_id) ?? Infinity;

              // Primero ordena por concepto_id (según tu mapa de prioridad)
              if (prioridadA !== prioridadB) {
                return prioridadA - prioridadB;
              }

              // Si tienen la misma prioridad, ordena por nro_cuota
              return a.nro_cuota - b.nro_cuota;
            });

            const conceptoControl = {};
            this.plan_pagos = this.plan_pagos.map((plan) => {
              const concepto = plan.concepto_pago;
              const saldo = parseFloat(plan.saldo.toFixed(2));
              
              const puedeAgregar =
                saldo > 0 && !conceptoControl[concepto];

              if (puedeAgregar) {
                conceptoControl[concepto] = true;
              }

              return {
                ...plan,
                canAdd: puedeAgregar, 
              };
            });

          } else {
            this.plan_pagos.sort((a, b) => b.numero_cuota - a.numero_cuota);
            this.plan_pagos.sort((a, b) => {
              if (a.concepto_id == b.concepto_id) {
                if (a.numero_cuota < b.numero_cuota && a.saldo > 0) {
                  b.canAdd = false;
                  a.canAdd = true;
                } else {
                  a.canAdd = false;
                  b.canAdd = true;
                }
              } else {
                if (this.plan_pagos.length <= 2) {
                  a.canAdd = true;
                  b.canAdd = true;
                }
              }
              return a.concepto_id - b.concepto_id || a.numero_cuota - b.numero_cuota;
            });
          }

          //window.console.log( pila );
          if (this.plan_pagos.length === 1) {
            this.plan_pagos[0].canAdd = true;
          }
        }
      },

      addItems(cuota, monto = 0) {
        //window.console.log('addItemsssss', cuota);
        //this.desbloquearModuloMoodle();
        //if (!cuota.facturable) this.noFacturables.push(cuota);
        this.items.sort((a, b) => a.numero_cuota - b.numero_cuota);
        cuota.pago = cuota.monto;
        cuota.monto = monto ? monto : cuota.saldo;
        cuota.xmontox = monto;
        cuota.cantidad = 1; // nuevo
        // cuota.subtotal = cuota.monto * cuota.cantidad; // nuevo
        cuota.subtotal = Math.round(Number(cuota.monto * cuota.cantidad) * 100) / 100; // nuevo
        //window.console.log(cuota, monto, cuota.monto);
        //cuota.monto = parseInt(cuota.monto);
        this.items.push(cuota);
        this.fieldEditable();

        if (cuota && cuota.optional) {
          // TODO: duda... los pagos opcionales pueden ser añadido n veces por recibos o solo una vez
          let index = this.pagos_opcionales.indexOf(cuota);
          this.pagos_opcionales.splice(index, 1);
        } else {
          let index = this.plan_pagos.indexOf(cuota);
          this.plan_pagos.splice(index, 1);
        }
        this.fieldCanAdd();
        this.updateTotal();
      },
      removeItem(item) {
        //window.console.log(item);
        let index = this.items.indexOf(item);
        this.items.splice(index, 1);
        if (item.optional) {
          this.pagos_opcionales.push(item);
          this.pagos_opcionales.sort((a, b) => a.index - b.index);
        } else {
          item.monto = item.pago;
          this.plan_pagos.push(item);
        }
        this.removersuperiores(item);
        this.fieldEditable();
        this.fieldCanAdd();
        this.updateTotal();
      },
      removersuperiores(item) {
        //removemos los demas item superiores al concepto que se acaba se sacar
        this.items = this.items.filter((x) => {
          let xitem = x.concepto_id <= item.concepto_id;
          if (!xitem) {
            if (x.optional) {
              this.pagos_opcionales.push(x);
              this.pagos_opcionales.sort((a, b) => a.index - b.index);
            } else {
              x.monto = x.pago;
              this.plan_pagos.push(x);
            }
          }
          return xitem;
        });
      },
      updateTotal() {
        this.total = 0;
        let xtotal = 0;
        //this.items.forEach((item) => (this.total += +item.monto));
        this.items.forEach((item) => (xtotal += item.subtotal));
        xtotal = Math.round(Number(xtotal) * 100) / 100;
        this.total = xtotal;
      },
      updatesubtotal(item) {
        // item.subtotal = item.cantidad * item.monto; 
        item.subtotal = Math.round(Number(item.cantidad * item.monto) * 100) / 100;
        this.updateTotal();
      },
      convertFechaPago(fp){
        const fs = fp.split('/');
        return `${fs[2]}-${fs[1]}-${fs[0]}T00:00:00-04:00`
      },

      async saveData() {
        /*this.items.forEach((x) => {
          window.console.log('item:::::', x);
        });
        let a = 1;
        if (a < 3) return;*/
        if (this.nitelectronico) {
          if (this.is_factura_directo && this.msgnofact == '') {
            let valido = this.$refs.facturaelectro.isValido();
            if (!valido) {
              this.$root.$notify.show(`Faltan completar algunos campos`, { color: 'danger', x: 'left' });
              return;
            }
          }
        }

        if (this.$refs.formRecibo.validate()) {
          if (
            await this.$root.$confirm.open('Generar Recibo', 'Estas seguro de guardar los nuevos datos?', {
              color: 'orange',
            })
          ) {
            let sedeid = this.isbenitojuarez ? this.sedeid_benitojuarez : this.$store.state.CARGO.idsede;
            let formData = {
              unidad_negocio_id: this.$store.state.UNIDAD_NEGOCIO_ID,
              inscripcion_id: this.programa.id,
              numero_factura: this.num_factura ? this.num_factura.trim() : null, // puede ser null
              nombre_depositante: this.nombre_depositante ? this.nombre_depositante.trim() : null, // puede ser null
              numero_documento_depositante: this.num_doc_depositante ? this.num_doc_depositante.trim() : null, // puede ser null
              forma_pago_id: this.forma.id,
              cuenta_bancaria_id: this.cuenta ? this.cuenta.id : null, // puede ser null
              numero_cuenta: this.cuenta ? this.cuenta.nro : null, // puede ser null
              asesor_id: this.programa.asesor_id, // puede ser null diferencia y obtencio de dato ??
              emisor_id: this.$store.state.DATA_USER.id, // puede ser null
              sede_id: sedeid, //
              numero_comprobante: this.numero_deposito ? this.numero_deposito.trim() : null, // FIXME SOLO PERMITE NUMERO,
              fondo_recibo: this.$store.state.CARGO.sede.modelo_recibo, // puede ser null //
              fecha_pago: this.fecha_pago,
              // fecha_pago: this.convertFechaPago(this.fecha_pago),
              tipo_pago: true, // true tiene plan de pagos
              lugar: this.$store.state.CARGO.sede.nombre, // sede.nombre
              cuotas: this.items.map((item) => {
                return {
                  cuota_id: item.optional ? null : item.id,
                  concepto: `${item.concepto} - ${item.numero_cuota}`,
                  monto: +item.monto,
                  concepto_id: item.concepto_id,
                  opcional: item.optional,
                  cantidad: item.cantidad,
                  precio_unitario: +item.monto * item.cantidad,
                };
              }),
              // cuotas: this.items.map((item) => {
              //   return {
              //     cuota_id: item.optional ? null : item.id,
              //     concepto: `${item.concepto} - ${item.numero_cuota}`,
              //     monto: +item.monto * item.cantidad,
              //     concepto_id: item.concepto_id,
              //     opcional: item.optional,
              //     cantidad: item.cantidad,
              //     precio_unitario: +item.monto,
              //   };
              // }),
            };
            window.console.log(JSON.stringify(formData, null, 4));
            /*let a = 2;
            if (a > 1) return;*/

            const url = `${this.api_rest}/api/pagos/inscripcion`;
            if (this.programa.estado_inscripcion == 1) {
              this.enviando = true;
              xaxios
                .post(url, formData)
                .then((res) => {
                  let recibo_id = res.data.recibo_id;
                  window.console.log(res.data, recibo_id);
                  this.sucess(recibo_id);
                })
                .catch((error) => {
                  this.enviando = false;
                  this.$root.$notify.show(`${error.response ? error.response.data.error : 'Error en la Transaccion'}`, {
                    color: 'red',
                    timeout: 5000,
                  });
                });
            } else {
              this.$root.$notify.show(
                `${'No se puede generar el recibo por que el estudiante se encuentra retirado o preinscrito'}`,
                { color: 'red' },
              );
            }
          }
        }else{
          this.$root.$notify.show(`Faltan completar algunos campos`, { color: 'red', x: 'right' });
        }
      },
      maxDate() {
        return new Date().toISOString().substr(0, 10);
      },
      sucess(recibo_id) { 
        this.desbloquearModuloMoodle();

        // descomentar
        if (this.nitelectronico && this.is_factura_directo && this.msgnofact == '') {
          this.$root.$notify.show('Generando la factura...', { color: 'success' });
          this.generarfactura(recibo_id); 
          this.$emit('reloadRecibos', false,recibo_id);
        } else {
          this.$root.$notify.show('Transaccion Realizada', { color: 'success' });
          this.$emit('reloadRecibos', true,recibo_id);
          this.closeDialog();
        }
      },

      async desbloquearModuloMoodle() {
        if (!this.plataforma) return;
        let pagos_anteriores = false;
        this.items.forEach((p) => {
          let date = new Date(p.fecha_pago);
          let now = new Date();
          if (date < now && p.saldo == 0) {
            pagos_anteriores = true;
          }
        });
        if (!pagos_anteriores) {
          const msg = `Aun hay deuda pendiente, desbloqueo automatico de moodle no aplicado.`;
          this.$root.$notify.show(msg, {
            color: 'orange',
            x: 'right',
          });
          return;
        }

        // const p_id = this.programa.programa_id;
        // const personas = [{ ...this.persona }];
        // const newestado = 1;
        // const pl = this.plataforma;
        // const res = await this.cobranzaService.cambiarEstadoInModulosMoodle(p_id, personas, pl, newestado);
        // window.console.log('Moodle desbloqueo: ', res);
      },

      closeDialog() {
        let vue = this;
        this.dialog = false;
        this.$nextTick(() => {
          vue.persona = null;
          vue.con_factura = false;
          vue.personas = [];
          vue.one_cobro_programa = null;
          vue.programa = null;
          vue.programas = [];
          vue.plan_inscripcion = null;
          vue.plan_pagos = [];
          vue.cuenta = null;
          vue.forma = null;
          vue.num_factura = null;
          vue.nombre_depositante = null;
          vue.num_doc_depositante = null;
          vue.cuentas_bancarias = [];
          vue.existsPlanPagos = false;
          vue.numero_deposito = null;
          vue.enviando = false;
          vue.pagos_opcionales = [];
          vue.existRecibo = false;
          vue.searchPersona = '';
        });
      },

      getCuentasBancarias(sede_id) {
        this.numero_deposito = null;
        this.cuenta = null;
        const sql = gql`query{getSede(id: ${sede_id}) { id, nombre, cuentasBancarias{ id, nombre, descripcion, nro, estado } ${''}}}`;
        this.$apollo.query({ query: sql }).then(({ data }) => {
          this.cuentas_bancarias = data.getSede.cuentasBancarias
            ? data.getSede.cuentasBancarias.map((c_bank) => {
                c_bank.nombre = c_bank.nombre + '  -  ' + c_bank.nro;
                return c_bank;
              })
            : [];
          this.cuentas_bancarias = this.cuentas_bancarias.filter((cb) => cb.estado);
        });
        if (this.nitelectronico /* && this.is_factura_directo */) {
          this.$refs.facturaelectro.getformapago(this.forma.id);
        }
      },
      getProgramas(student_id) {
        this.loadingprogramas = true;
        this.msgprogs = '';
        this.razonestxt = '';
        const vue = this;
        //id del estudiante para ver todos sus programas a los q esta inscrito
        const url = `${this.api_rest}/api/esam/inscripcion/estudiante/id/${student_id}`;
        xaxios.get(url).then(({ data }) => {
          if (!data) data = []; // cuando esta doble registro creo :)
          //window.console.log('getProgramas', data);
          this.programas = [];
          // filtramos los programas donde esta inscrito estado = 1
          let total = data.length;
          data = data.filter((x) => {
            if (x.estado_inscripcion != 1)
              vue.razonestxt += `- Estado de la inscripcion no valida en el programa: ${x.programa.nombre_compuesto}<br/><br/>`;
            return x.estado_inscripcion == 1;
          });
          //==========================================
          //para benito juarez filtrar solo diplomados
          //==========================================
          if (this.isbenitojuarez) {
            data = data.filter((x) => {
              return x.programa.categoria_id == 1;
            });
          } else {
            data = data.filter((x) => {
              let res = x.programa.sede_id == this.$store.state.CARGO.sede.id;
              if (!res)
                vue.razonestxt += `- El estudiante esta inscrito en un programa que pertenece a otra sede (${x.programa.nombre_compuesto}), IDSEDE:${x.programa.sede_id}).<br/><br/>`;
              return res;
            });
          }

          window.console.log('insc.estado::', data);

          data.forEach((insc) => {
            //window.console.log('insc.estado::', insc.estado);

            if (insc.estado /*&& insc.programa.sede_id == this.$store.state.CARGO.sede.id*/) {
              insc.programa = Object.assign(insc.programa, {
                asesor_id: insc.asesor_id,
                plan_id: insc.plan_id,
                estado_inscripcion: insc.estado_inscripcion,
                plan_pagos: insc.plan_pagos,
                planes: insc.programa.planes
                  ? insc.programa.planes.filter((p_item) => p_item.plan_cobro_programa_id === insc.plan_id)
                  : [],
                id: insc.id,
                estudiante_id: insc.estudiante_id,
                estado_plan_id: insc.estado_plan_id,
                aprobado_plan_user_id: insc.aprobado_plan_user_id ? insc.aprobado_plan_user_id : null,
                ifcode: insc.programa.codigo ? true : false,
                ifSucursalId: insc.programa.sucursal_id ? true : false,
                codigo: insc.programa.codigo ? insc.programa.codigo : ``,
              });
              insc.programa.nombre_compuesto = `${insc.programa.codigo}  ${insc.programa.nombre_compuesto}`;
              this.programas.push(insc.programa);
            } else {
              vue.razonestxt += `- Estado de la inscripcion no activa (${insc.programa.nombre_compuesto})<br/><br/>`;
            }
            this.programa = this.programas.length ? this.programas.reverse()[0] : null;
          });
          let total2 = this.programas.length;
          this.msgprogs = `${total} programas encontrados, ${total2} disponibles para generar recibos.`;
          this.loadingprogramas = false;
          //window.console.log('razones: ', this.razonestxt);
        });
      },
      verrazones() {
        this.$refs.arazones.openmodal(this.razonestxt);
      },
      generarfactura(recibo_id) {
        this.xreciboelectro = null;
        let vue = this;
        const url = `${this.api_rest}/api/pagos/recibos/id/${recibo_id}`;
        xaxios
          .get(url)
          .then((res) => {
            let data = res.data;
            let total = 0;
            data.detalle.map((item, i = 0) => {
              item.index = i++;
              item.numero_cuota = item.concepto.split(' - ')[1];
              item.concepto_name = item.concepto.split(' - ')[0];
              let cuota = vue.plan_pagos.find((pp) => pp.id == item.cuota_id);
              item.importe = item.monto;
              item.descuento = cuota ? cuota.descuento : 0;
              item.saldo = cuota ? cuota.saldo : 0;
              item.fecha_de_pagar = data.fecha_pago;
              total += item.importe;
              return item;
            });
            data.total = total;
            window.console.log('getreciboid:::', data);
            vue.xreciboelectro = data;
            let recibo = data;
            let estudiante = window.Object.assign({}, vue.persona);
            estudiante.nombres = estudiante.nombres.replace(vue.persona.pri_apellido, '');
            estudiante.nombres = estudiante.nombres.replace(vue.persona.seg_apellido, '');
            estudiante.nombres = (estudiante.nombres + '').replace(/\s+/g, ' ');
            estudiante.nombres = (estudiante.nombres + '').trim();

            let sucursal = vue.xsucursal;
            vue.$refs.facturaelectro.showThisView(recibo, estudiante, sucursal, false,vue.programa);
            vue.$refs.facturaelectro.setLoadingFromRecbos(true);
            /*setTimeout(() => {
              if(this.xloadstatusconceptos) return;
              vue.$refs.facturaelectro.emitirfactura();
            }, 5000);*/
          })
          .catch((error) => window.console.log(error));
      },
      onloadallconceptos() {
        window.console.log('xloadstatusconceptos....');
        this.xloadstatusconceptos = true;
        let vue = this;
        setTimeout(() => {
          vue.$refs.facturaelectro.emitirfactura();
        }, 2000);
      },
      onfacturagenerada(ventaid, xrecibo, data, factura) {
        this.$refs.refFacturaePrint.showThisView(ventaid, xrecibo, data, factura);
        this.closeDialog();
        let vue = this;
        setTimeout(() => {
          vue.$emit('reloadRecibos', false);
        }, 1500);
      },
      onfacturafalled(msg) {
        this.enviando = false;
        this.$root.$notify.show(`Genere la factura ${msg}`, { color: 'orange' });
        this.$emit('reloadRecibos', true);
        this.closeDialog();
      },
      fanulada() {
        //this.$set(this.recibo, 'factura_id', null);
        //this.puedefacturar = false;
        this.closeDialog();
      },
      anuladofact() {
        // anular la facturaid de recibos con el endpoint
        //this.recibo.factura_id = null;
        //this.puedefacturar = true;
        if (this.xreciboelectro) this.guardarFacturaNulRecibo(null, this.xreciboelectro.id);
      },

      guardarFacturaNulRecibo(idfactura, idrecibo) { 
        let vue = this;
        var config = {
          method: 'put',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/recibo/addfactura`,
          headers: {
            'Content-Type': 'application/json',
          },
          data: {
            recibo_id: idrecibo,
            factura_id: idfactura,
            numero_factura: null,
            nit: null,
          },
        };

        xaxios(config)
          .then(function (response) {
            let data = response.data;
            window.console.log('guardarFacturaNulRecibo:> ', data);
            vue.$emit('reloadRecibos');
          })
          .catch(function (error) {
            let data = error.response.data;
            window.console.log(data);
          });
      },
      async getFormasdePago() {
        if (this.formas_pago.length > 0) return;
        let vue = this;
        vue.loadingformas = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/formaspagos`,
          headers: {},
        };

        // window.console.log("AQQQQUUUU PODRIA FALLAR 33333");
        await xaxios.request(config)
          .then(function (response) {
            let data = response.data.data;
            vue.formas_pago = data;
            vue.loadingformas = false;
          })
          .catch(function (error) {
            window.console.log(error);
            vue.loadingformas = false;
          });
      },
      getSedes() {
        this.$apollo
          .query({
            query: gql`query{getSedes{id,nombre} ${''}}`,
          })
          .then((data) => {
            var dat = data.data.getSedes;
            window.console.log('getSedes:> ', dat);
          })
          .catch((error) => {
            window.console.error(error);
          });
      },

      verificar_is_upi(){
        const e = (window.location.href+'')
        window.console.log('SEDE::::', this.programa, e);
        
        // if((e.includes('localhost') || e.includes('webdev')) && this.programa.universidad_id == 301 ){
        if(this.programa.universidad_id == 301 ){
          this.is_upi = true
        }
      },
      open_duplicar_in_q10(){ 
        // window.console.log('this.programa',this.programa, this.persona);
        this.$refs.refmodal_propuesta_duplicar.openmodal(this.programa,this.persona) 
      }
    },
    mounted() {
      this.date = this.getGMTMinus4Date();
      window.console.log('this.date ',this.date );
      
      this.isbenitojuarez = location.href.includes('recibosbenito');
      this.fecha_pago = this.formatDate(this.date);
    },
  };
</script>
<style>
  .max-height {
    max-height: 4.5em;
  }
  .mora-mes-1 {
    background-color: #fb706d78;
  }
  .mora-semana-1 {
    background-color: #ffe17694;
  }
  .regularizado {
    background-color: #0076fb5e;
  }
  .descuento {
    background-color: #08fb005e;
  }
</style>
